import {
  Box,
  Grid,
  Icon,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Tooltip,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { api_request } from "../../store/actions/commonAction";
import {
  API_METHOD_GET,
  API_METHOD_POST,
  API_METHOD_PUT,
  ENTITY_STATUS,
} from "../../config/constants";
import {
  DELETE_TABLE_DATA_ERROR,
  DELETE_TABLE_DATA_SUCCESS,
  FETCH_PERMISSION_TABLE_ERROR,
  FETCH_ROLE_TABLE_ERROR,
  FETCH_ROLE_TABLE_SUCCESS,
  UPDATE_TABLE_DATA_ERROR,
  UPDATE_TABLE_DATA_SUCCESS,
} from "../../store/types/manageDataTypes";
import CoreIconButton from "../../core/inputs/CoreIconButton";
import { setManageDataReducer } from "../../store/actions/manageDataAction";
import { theme } from "../../config/theme";
import Swal from "sweetalert2";
import AssignPermissionsModal from "./AssignPermissionsModal";
import MasterDataEditModal from "./MasterDataEditModal";
import CoreButton from "../../core/inputs/CoreButton";
import AddRoleAndPermission from "./AddRoleAndPermission";

const columns = ["id", "role", "priority", "_status", "defaultTool"];

export default function ManageRoles() {
  const dispatch = useDispatch();

  const roleTable = useSelector((state) => state?.manageData?.roleTable);

  const insertTableDataSuccess = useSelector(
    (state) => state?.manageData?.insertTableDataSuccess
  );
  const insertTableDataError = useSelector(
    (state) => state?.manageData?.insertTableDataError
  );
  const insertTableDataMsg = useSelector(
    (state) => state?.manageData?.insertTableDataMsg
  );

  const updateTableDataSuccess = useSelector(
    (state) => state?.manageData?.updateTableDataSuccess
  );
  const updateTableDataError = useSelector(
    (state) => state?.manageData?.updateTableDataError
  );
  const updateTableDataMsg = useSelector(
    (state) => state?.manageData?.updateTableDataMsg
  );

  const deleteTableDataSuccess = useSelector(
    (state) => state?.manageData?.deleteTableDataSuccess
  );
  const deleteTableDataError = useSelector(
    (state) => state?.manageData?.deleteTableDataError
  );
  const deleteTableDataMsg = useSelector(
    (state) => state?.manageData?.deleteTableDataMsg
  );

  const [editItemDetail, setEditItemDetail] = useState(null);
  const [showAddModal, setShowAddModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [showAssignPermissionModal, setShowAssignPermissionModal] =
    useState(false);
  const [role, setRole] = useState(null);

  useEffect(() => {
    getRoles();
  }, []);

  useEffect(() => {
    if (insertTableDataSuccess) {
      setShowAddModal(false);
      dispatch(setManageDataReducer({ insertTableDataSuccess: false }));
      getRoles();
      Swal.fire({
        title: "Success",
        text: insertTableDataMsg,
        icon: "success",
        confirmButtonColor: theme.palette.primary.main,
      });
    }
    if (insertTableDataError) {
      dispatch(setManageDataReducer({ insertTableDataError: false }));
      Swal.fire({
        title: "Oops!",
        text: insertTableDataMsg,
        icon: "error",
        confirmButtonColor: theme.palette.primary.main,
      });
    }
  }, [insertTableDataSuccess, insertTableDataError]);

  useEffect(() => {
    if (updateTableDataSuccess) {
      setShowEditModal(false);
      dispatch(setManageDataReducer({ updateTableDataSuccess: false }));
      getRoles();
    }
    if (updateTableDataError) {
      setShowEditModal(false);
      Swal.fire({
        title: "Error",
        text: updateTableDataMsg,
        icon: "error",
        confirmButtonColor: theme.palette.primary.main,
      });
      dispatch(setManageDataReducer({ updateTableDataError: false }));
    }
  }, [updateTableDataSuccess, updateTableDataError]);

  useEffect(() => {
    if (deleteTableDataSuccess) {
      dispatch(setManageDataReducer({ deleteTableDataSuccess: false }));
      Swal.fire({
        title: "Success",
        text: deleteTableDataMsg,
        icon: "success",
        confirmButtonColor: theme.palette.primary.main,
      });
      getRoles();
    }
    if (deleteTableDataError) {
      dispatch(setManageDataReducer({ deleteTableDataError: false }));
      Swal.fire({
        title: "Oops!",
        text: deleteTableDataMsg,
        icon: "error",
        confirmButtonColor: theme.palette.primary.main,
      });
    }
  }, [deleteTableDataSuccess, deleteTableDataError]);

  const getRoles = () => {
    dispatch(
      api_request(
        API_METHOD_GET,
        "/data/Roles",
        null,
        null,
        null,
        FETCH_ROLE_TABLE_SUCCESS,
        FETCH_ROLE_TABLE_ERROR,
        true,
        false,
        true
      )
    );
  };

  const onEdit = (value) => {
    dispatch(
      api_request(
        API_METHOD_PUT,
        `/data/Roles/${editItemDetail.id}/update`,
        { [editItemDetail.col]: value },
        null,
        null,
        UPDATE_TABLE_DATA_SUCCESS,
        UPDATE_TABLE_DATA_ERROR,
        true,
        false,
        true
      )
    );
  };

  const onDelete = (id) => {
    Swal.fire({
      title: "Are you sure?",
      text: "If you proceed, the item will be permanently deleted from the database. If you prefer a soft delete, please update its _status field to 'delete' instead.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: theme.palette.primary.main,
      cancelButtonColor: theme.palette.error.main,
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        dispatch(
          api_request(
            API_METHOD_POST,
            "/data/Roles/delete",
            { tableIds: [id] },
            null,
            null,
            DELETE_TABLE_DATA_SUCCESS,
            DELETE_TABLE_DATA_ERROR,
            true,
            false,
            true
          )
        );
      }
    });
  };

  return (
    <Box style={{ width: "100%" }}>
      <Box style={{ padding: "16px" }}>
        <AssignPermissionsModal
          show={showAssignPermissionModal}
          onClose={() => {
            setShowAssignPermissionModal(false);
          }}
          role={role}
        />
        <AddRoleAndPermission
          show={showAddModal}
          onClose={() => {
            setShowAddModal(false);
          }}
          table="Roles"
        />
        <MasterDataEditModal
          show={showEditModal}
          col={editItemDetail?.col}
          value={
            editItemDetail &&
            roleTable?.find((f) => f.id === editItemDetail?.id) &&
            roleTable?.find((f) => f.id === editItemDetail?.id)[
              editItemDetail?.col
            ]
          }
          options={
            editItemDetail?.col === "_status"
              ? Object.keys(ENTITY_STATUS).map((item) => {
                  return {
                    value: ENTITY_STATUS[item],
                    label: ENTITY_STATUS[item],
                  };
                })
              : []
          }
          onClose={() => {
            setShowEditModal(false);
          }}
          onSubmit={onEdit}
        />
        <Grid container>
          <Grid item xs={4}>
            <CoreButton
              onClick={() => {
                setShowAddModal(true);
              }}
            >
              Add Role
            </CoreButton>
          </Grid>
          <Grid item xs={12}>
            <Paper style={{ marginTop: "12px" }}>
              {roleTable && (
                <Table size="small">
                  <TableHead>
                    <TableRow>
                      <TableCell style={{ textAlign: "" }}>Action</TableCell>
                      {columns.map((item, index) => (
                        <TableCell key={index}>{item}</TableCell>
                      ))}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {[...roleTable]
                      .sort((a, b) => (a?.id > b?.id ? 1 : -1))
                      .map((item) => (
                        <TableRow key={item.id}>
                          <TableCell align="center">
                            <Box display="flex" justifyContent="center" gap={1}>
                              <Tooltip title="Delete">
                                <CoreIconButton
                                  size="small"
                                  color="error"
                                  onClick={() => {
                                    onDelete(item.id);
                                  }}
                                >
                                  <Icon style={{ fontSize: "20px" }}>
                                    delete
                                  </Icon>
                                </CoreIconButton>
                              </Tooltip>
                              <Tooltip title="Assign Permissions">
                                <CoreIconButton
                                  size="small"
                                  color="secondery"
                                  onClick={() => {
                                    setRole(item);
                                    setShowAssignPermissionModal(true);
                                  }}
                                >
                                  <Icon style={{ fontSize: "20px" }}>edit</Icon>
                                </CoreIconButton>
                              </Tooltip>
                            </Box>
                          </TableCell>
                          {columns.map((col, colIndex) => (
                            <TableCell
                              key={item.id + colIndex}
                              sx={{
                                whiteSpace: "nowrap",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                maxWidth: 200, // set a max width as needed
                              }}
                              onClick={() => {
                                if (col !== "id") {
                                  setEditItemDetail({ id: item.id, col: col });
                                  setShowEditModal(true);
                                }
                              }}
                            >
                              {typeof item[col] !== "object"
                                ? item[col]
                                : JSON.stringify(item[col])}
                            </TableCell>
                          ))}
                        </TableRow>
                      ))}
                  </TableBody>
                </Table>
              )}
            </Paper>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
}
